<template>
  <div class="form-check form-switch text-center">
    <input class="form-check-input" :checked="isChecked" type="checkbox" @change="onCheckChanged">
  </div>
</template>

<script lang="js">
import Vue from 'vue'
export default Vue.extend({
  data: function () {
    return {
      isChecked: false
    }
  },
  beforeMount(){
    this.isChecked = this.params.data[this.params.column.colId];
  },
  methods: {
    onCheckChanged(event) {
      let checked = event.target.checked;
      this.params.node.setDataValue(this.params.column.colId, checked)
      this.params.onCheckChangedCallback(this.params.node, checked)
    }
  }
})
</script>